
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withOnlineStatus } from 'op/components/offline';

export const TAGS_PAGE_SIZE = 10;

export const withFormItemReports = compose(
	withAxios,
	connect(({ forms }, { match }) => ({
		item: forms.loaded.find(item => item.ASM_Item_ID.toString() == match.params.item_id),
	})),
	withProps(({ item }) => ({ ready: !!item })),
	withState('search', 'setSearch', ''),
	withState('loading', 'setLoading', false),
	withState('formItemReports', 'setFormItemReports', []),
	withOnlineStatus,
	withHandlers({
		fetchFormItemReports: ({ item, setLoading, formItemReports, setFormItemReports, axios }) => async ({ page = 0 }) => {
			setLoading(true);

			const skip = page * 10;
			const top = 10;

			const { data } = await axios.get('/api/Forms/getFormReportByItemId', {
				params: {
					itemId: item.ASM_Item_ID,
					skip,
					top,
				}
			});

			setFormItemReports([...formItemReports, ...data]);
			setLoading(false);
		}
	}),
);
